export default "__VITE_ASSET__86e654c6__"